import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { CheckCircleIcon, InactiveCheckIcon } from './icons';

export interface PaymentProgressProps {
    fromAmount: string;
    toAmount?: string;
    toName?: string;
    status?: number;
    transactionAction: string;
    fromName?: string;
}

const PaymentProgress = ({
    fromAmount,
    toAmount,
    toName,
    status,
    transactionAction,
    fromName
}: PaymentProgressProps) => {
    const { user } = useSelector((state: RootState) => state.user);

    return (
        <div className='bg-white border-appcolorfaintnine border rounded-[16px] p-6'>
            <div className='flex'>
                <CheckCircleIcon />
                <div className='ml-2'>
                    <p className='text-gray700 font-semibold text-sm'>
                        {fromName || '-'}
                    </p>
                    <p className='text-ebony text-sm leading-[20px]'>
                        {fromAmount || '-'}
                    </p>
                </div>
            </div>

            <div className='h-[46px] w-[2px] bg-primary500 ml-4 rounded-[2px] mb-[6px]' />

            <div className='flex'>
                {status === 1 ? <CheckCircleIcon /> : <InactiveCheckIcon />}

                <div className='ml-2'>
                    <p className='text-gray700 font-semibold text-sm'>
                        {toName || '-'}
                    </p>
                    <p className='text-ebony text-sm leading-[20px]'>
                        {toAmount || '-'}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PaymentProgress;
